import { render, staticRenderFns } from "./TomaNew.vue?vue&type=template&id=0934fdbc&scoped=true"
import script from "./TomaNew.vue?vue&type=script&lang=js"
export * from "./TomaNew.vue?vue&type=script&lang=js"
import style0 from "./TomaNew.vue?vue&type=style&index=0&id=0934fdbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0934fdbc",
  null
  
)

export default component.exports